import { TFunction } from "i18next";
import * as Yup from "yup";

export const getSecurityIPFormSchema = (t: TFunction) => {

    return Yup.object().shape({
        ipOrigin: Yup.string()
            .required(t("common:form.requiredFieldForm"))
            .typeError(t("common:form.invalidDateForm")),
    });
};